<template>
  <div>
    <v-row no-gutters v-if="fieldsLoading">
      <v-col v-for="n in 25" :key="n" cols="12" sm="6" lg="3">
       <v-sheet class="mt-2">
        <v-skeleton-loader class="mx-auto" type="list-item"></v-skeleton-loader>
      </v-sheet>
      </v-col>
    </v-row>
    <template v-else>
      <v-card>
        <fields :model="modelObj" ref="productReference"
          :isWorkType="isWorkType" :showPriceUpdateText="showPriceUpdateText"
          @gross-margin="setGrossMarginValue" :copyProduct="copyProduct"
          :isAdmin="isAdmin"
          :list="{ groups: [...listOfProductGroups], units: [...listOfUnits], sales_accounts: [...listOfSalesAccounts], warehouse: [...listOfWarehouse] }"
          @supportingList="supportingList" :key="reInitFields">
        </fields>
        <v-card class="pb-2 mb-5" v-if="modelObj.id && modelObj.ispackage">
          <v-card-title class="pb-0">
            {{ $t('message.layout.products') }}
            <v-spacer></v-spacer>
            <v-btn color="primary" class="mb-1" @click="getContentHandler" :loading="contentLoader">{{ $t('message.orders.contents') }}</v-btn>
          </v-card-title>
          <v-divider class="mb-3"></v-divider>
          <packageproducts :model="modelObj" :modelId="modelObj.id" :list="{ suppliers: [...listOfSuppliers] }"
            @priceUpdate="priceCalculation"></packageproducts>
        </v-card>
        <v-expansion-panels v-if="!modelObj.isinformation">
          <suppliers v-if="isWorkType && modelObj.id" :model="modelObj" :isAdmin="isAdmin" :list="{ suppliers: [...listOfSuppliers], currencies: [...listOfCurrencyList], priceTypes: typeOfPriceCal }"></suppliers>
          <measures :model="modelObj"></measures>
          <attachments :model="modelObj" v-if="modelObj.id" :key="reInit" :module="SP_PRODUCT"></attachments>
          <openorders :model="modelObj" v-if="modelObj.id"></openorders>
          <batches :model="modelObj" v-if="modelObj.id"></batches>
          <pricehistory :model="modelObj" v-if="modelObj.id"></pricehistory>
        </v-expansion-panels>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" :loading="loading" @click="saveUpdateHandler(SAVE)" :disabled="disableBtn || isTechnician">{{ modelObj.id ? $t('message.common.update') : $t('message.common.save') }}</v-btn>
          <v-btn color="primary" :loading="loading" @click="saveUpdateHandler(UPDATE_CLOSE)" :disabled="disableBtn || isTechnician" v-if="modelObj.id">{{ $t('message.common.updateAndClose') }}</v-btn>
          <v-btn color="info" @click="$router.go(-1)">{{ $t('message.common.backToList') }}</v-btn>
          <v-btn color="error" @click="deleteHandler" :disabled="!isAdmin" v-if="modelObj.id">{{ $t('message.common.delete') }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
      <v-dialog v-model="nestedDialog" persistent width="1000">
        <v-card>
          <v-card-text class="pt-3">
            <v-simple-table dense width="100%" class="dense_table bordered--table">
              <thead>
                <tr>
                  <th>{{ $t('message.layout.product') }}</th>
                  <th>{{ $t('message.product.suppliers') }}</th>
                  <th>{{ $t('message.whOrder.unitCost') }}</th>
                  <th>{{ $t('message.product.salesPrice') }}</th>
                  <th>{{ $t('message.order.qty') }}</th>
                  <th>{{ $t('message.common.comments') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(product, i) in nestedContents" :key="i">
                  <td class="pa-1" :class="`pl-${product.paddingindex}`">{{ product.productnumber }} {{ product.productname }}</td>
                  <td class="pa-1">{{ product.suppliername }}</td>
                  <td class="pa-1 text-right">{{ product.unitcost | replaceDotWithComma }}</td>
                  <td class="pa-1 text-right">{{ product.salesprice | replaceDotWithComma }}</td>
                  <td class="pa-1 text-right">{{ product.qty | replaceDotWithComma }}</td>
                  <td class="pa-1">{{ product.comments }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" @click="nestedDialog = false">{{ $t('message.common.close') }} </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="copyProduct.dialog" persistent width="1000" fullscreen>
        <v-card>
          <fields :model="copyPayload" ref="copyProductReference"
            :isWorkType="isWorkType" :showPriceUpdateText="showPriceUpdateText"
            @gross-margin="setGrossMarginValue" :copyProduct="{ ishow: false }"
            :list="{ groups: [...listOfProductGroups], units: [...listOfUnits], sales_accounts: [...listOfSalesAccounts], warehouse: [...listOfWarehouse] }"
            @supportingList="supportingList" :key="reInitFields">
          </fields>
          <v-card class="pb-2 mb-5" v-if="copyPayload.ispackage">
            <v-card-title class="pb-0">
              {{ $t('message.layout.products') }}
              <v-spacer></v-spacer>
              <v-btn color="primary" class="mb-1" @click="getContentHandler" :loading="contentLoader">{{ $t('message.orders.contents') }}</v-btn>
            </v-card-title>
            <v-divider class="mb-3"></v-divider>
            <packageproducts :model="copyPayload" :modelId="modelObj.id" :list="{ suppliers: [...listOfSuppliers] }"
              @priceUpdate="priceCalculation"></packageproducts>
          </v-card>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" :loading="loading" @click="saveUpdateHandler(SAVE, true)">{{ $t('message.common.save') }}</v-btn>
            <v-btn color="info" @click="copyProduct.dialog = false">{{ $t('message.common.close') }}</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </div>
</template>
<script>
import moment from 'moment'
/* eslint-disable camelcase */
import { mapState, mapGetters } from 'vuex'
export default {
  data () {
    return {
      fieldsLoading: false,
      modelObj: {
        id: this.$route.params.product_id,
        type: '',
        costprice: '',
        grosmargin: '',
        salesprice: ''
      },
      MODULE_URL: 'products',
      loading: false,
      productTransformList: ['costprice', 'grosmargin', 'salesprice', 'salespriceincvat', 'baseprice', 'available', 'minstock', 'orderqty', 'leadtime',
        'length', 'width', 'thickness', 'weight', 'radius', 'area', 'minlength', 'minwidth', 'minthickness',
        'maxlength', 'maxwidth', 'maxthickness', 'grossweight'],
      packageProducts: [],
      packageProductsError: false,
      listOfCurrencyList: [],
      disableBtn: false,
      reInit: 0,
      reInitFields: 0,
      canReloadDocument: false,
      showPriceUpdateText: false,
      actualPriceDate: '',
      contentLoader: false,
      nestedContents: [],
      nestedDialog: false,
      copyProduct: {
        isshow: true,
        dialog: false,
        open: () => {
          this.copyHandler()
        }
      },
      copyPayload: {}
    }
  },
  watch: {
    'modelObj.priceValidFromPicker' (val) {
      if (val) {
        this.modelObj.pricevalidfrom = this.$formatter.formatDate(val, 'YYYY-MM-DD', 'DD.MM.YYYY')
      }
    }
  },
  components: {
    fields: () => import('@/components/Product/Fields'),
    measures: () => import('@/components/Product/Measures'),
    suppliers: () => import('@/components/Product/Suppliers'),
    attachments: () => import('@/components/Attachments'),
    batches: () => import('@/components/Product/Batches'),
    packageproducts: () => import('@/components/Product/ProductPackage'),
    openorders: () => import('@/components/Product/OpenOrders'),
    pricehistory: () => import('@/components/Product/PriceHistory')
  },
  computed: {
    ...mapState(['listOfProductGroups', 'listOfUnits', 'listOfWarehouse', 'listOfSalesAccounts', 'listOfSuppliers']),
    ...mapGetters(['getuserDetails']),
    isWorkType () {
      if (this.modelObj.type && this.modelObj.type === 'work') return false
      else return true
    },
    isTechnician () {
      return this.getuserDetails ? this.getuserDetails.role === 3 : false
    },
    isAdmin () {
      return this.getuserDetails ? this.getuserDetails.role === 1 || this.getuserDetails.role === 0 : false
    },
    typeOfPriceCal () {
      return [{
        text: '%',
        value: '%'
      }, {
        text: 'NOK',
        value: 'NOK'
      }]
    }
  },
  created () {
    this.$store.dispatch('getSupplierList')
    this.$store.dispatch('getWarehouse')
    this.getAllCurrencyList()
    this.$store.dispatch('getProductGroups')
      .then(() => {
        if (!this.modelObj.id) {
          this.setDefaultValues({ prop: 'productgroupid', list: this.$store.state.listOfProductGroups })
        }
      })
    this.$store.dispatch('getUnits')
      .then(() => {
        if (!this.modelObj.id) {
          this.setDefaultValues({ prop: 'unitid', list: this.$store.state.listOfUnits })
        }
      })
    this.$store.dispatch('getSalesAccount')
      .then(() => {
        if (!this.modelObj.id) {
          this.setDefaultAccount()
        }
      })
  },
  mounted () {
    let text = this.$t('message.common.deleteMsg')
    this.$eventBus.$on('deleteSuccess', (data) => {
      this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
      this.$store.commit('hideDialog')
      if (data === this.MODULE_URL) this.$router.push('/w_h/products')
    })
    this.$eventBus.$on('setChildData', (data) => {
      if (data) {
        this.packageProducts = data
        this.packageProductsError = false
      } else {
        this.packageProductsError = true
        this.packageProducts = []
      }
    })
    this.$eventBus.$on('updateProductUnits', () => {
      this.getProductUnits().then(() => {
        this.reInitFields++
      })
    })
    this.$eventBus.$on('updateProductDefaultLocations', () => {
      this.getProductDefaultLocations().then(() => {
        this.reInitFields++
      })
    })
    this.$eventBus.$on('updatedSupplier', () => {
      this.getCostDetails()
    })
    this.$eventBus.$on('calculateGrosMarginValue', () => {
      this.calculateGrosMarginValue()
    })
    this.$eventBus.$on('calculateSalesValue', () => {
      this.calculatSalesPriceValue()
    })
    this.$eventBus.$on('checkForNumberDuplication', () => {
      this.checkForNumberDuplicationAndDisableBtn()
    })
    this.$eventBus.$on('salesPriceHandler', (data) => {
      this.salesCalculationHandler(data.target, data.field, data.type)
    })
    this.$root.$on('get_product_details', () => {
      this.canReloadDocument = true
      this.getSingleRecordHandler()
    })

    if (!this.modelObj.id) {
      this.modelObj.vatid = 25
      this.modelObj.isactive = true
      this.modelObj.stockitem = true
      this.modelObj.inventoryitem = true
      this.modelObj.grosmargin = '0'
      this.modelObj.minstock = '0'
      this.modelObj.orderqty = '0'
      this.modelObj.type = 'product'
      this.modelObj.pricevalidfrom = moment().format('DD.MM.YYYY')
      this.modelObj.units = []
      this.modelObj.defaultlocations = []
    } else this.getSingleRecordHandler()
    this.$eventBus.$on('setItemInField', (data) => {
      let model = Object.assign({ ...this.modelObj }, { [data.modelName]: data.recordId })
      this.modelObj = model
    })
  },
  methods: {
    checkForNumberDuplicationAndDisableBtn () {
      if (this.modelObj.number) {
        let model = {}
        if (this.modelObj.id) {
          model = { filter: `number eq '${this.modelObj.number}' and id ne ${this.modelObj.id}` }
        } else {
          model = { filter: `number eq '${this.modelObj.number}'` }
        }
        let url = `${this.MODULE_URL}/query/`
        this.$_executeApi('post', url, model)
          .then((response) => {
            if (response.data && response.data.length > 0) {
              this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.product.productWithSameNumberExists') })
              this.disableBtn = true
            } else {
              this.disableBtn = false
            }
          })
      }
    },
    getCostDetails () {
      this.$_getSingleRecordHandler(`${this.MODULE_URL}/${this.modelObj.id}`)
        .then((result) => {
          if (result.data) {
            let product = result.data
            let transformData = { number: { list: this.productTransformList, format: 'replaceDotWithComma' } }
            let model = this.$_formatModel(product, transformData)
            this.modelObj.costprice = model.costprice
            this.modelObj.grosmargin = model.grosmargin || 0
            this.modelObj.salesprice = model.salesprice
            // this.modelObj.baseprice = model.baseprice
            this.setGrossMarginValue()
          }
        })
    },
    getSingleRecordHandler () {
      this.fieldsLoading = true
      this.$_getSingleRecordHandler(`${this.MODULE_URL}/${this.modelObj.id}`)
        .then((result) => {
          if (result.data) {
            let product = result.data
            let transformData = { number: { list: this.productTransformList, format: 'replaceDotWithComma' },
              date: { list: ['pricevalidfrom'], from: 'DD.MM.YYYY', to: 'DD.MM.YYYY' } }
            let model = this.$_formatModel(product, transformData)
            this.actualPriceDate = model.pricevalidfrom
            this.modelObj = model
            this.getProductUnits().then(() => {
              this.getProductDefaultLocations().then(() => {
                this.fieldsLoading = false
                if (this.canReloadDocument) this.reInit++
                this.canReloadDocument = false
              })
            })
            this.modelObj.defaultlocations = []
          }
        })
    },
    saveUpdateHandler (type, iscopy = false) {
      var modelPayload = iscopy ? 'copyPayload' : 'modelObj'
      var validation = iscopy ? 'copyProductReference' : 'productReference'
      if (this.$refs[validation].$refs.validateForm.validate()) {
        if (this[modelPayload].units.length || this[modelPayload].isinformation) {
          this.$eventBus.$emit('savingParentObj')
          if (this.packageProductsError === false) {
            this.loading = true
            var previousDate = Date.parse(this.actualPriceDate)
            var updatedDate = Date.parse(this[modelPayload].pricevalidfrom)
            if (previousDate !== updatedDate) {
              this.showPriceUpdateText = true
              setTimeout(() => {
                this.showPriceUpdateText = false
              }, 4000)
            }
            let transformData = { number: { list: this.productTransformList, format: 'replaceCommaWithDot' },
              date: { list: ['pricevalidfrom'], from: 'DD.MM.YYYY', to: 'MM.DD.YYYY' } }
            if (!this[modelPayload].ispackage) this[modelPayload].openstructure = false
            let model = this.$_formatModel(this[modelPayload], transformData)
            let saleunitobj = model.units.find(x => x.issaleunit)
            if (saleunitobj) {
              model.unitid = saleunitobj.unitid
              model.barcode = saleunitobj.ean || ''
            }
            if (model.stockitem) {
              model.issupplieronorder = false
            }
            this.$_saveUpdateHandler(this.MODULE_URL, model)
              .then((response) => {
                this.$store.commit('isChangesMade', false)
                this.saveProductUnits(response.id, model.units).then(async () => {
                  await this.saveProductDefaultLocations(response.id, model.defaultlocations).then(() => {
                    this.savePackageProducts(response.id, type, model, iscopy)
                  })
                })
              })
              .finally(() => {
                this.loading = false
              })
          } else {
            this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
          }
        } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.product.addAtleastOneUnit') })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    },
    savePackageProducts (id, type, model, iscopy) {
      this.loading = true
      let transformData = { number: { list: ['qty', 'unitcost', 'salesprice'], format: 'replaceCommaWithDot' } }
      let items = this.$formatter.cloneVariable(this.packageProducts)
      items.forEach(x => {
        if (iscopy) x.id = 0
        x.packageid = id
      })
      items = this.$_formatListModel(items, transformData)
      let url = `/productpackages/bulk_save/${id}`
      this.$_executeApi('post', url, items)
        .then((response) => {})
        .finally(() => {
          this.loading = false
          this.navigationHandler(type, model, id)
        })
    },
    saveProductUnits (productId, units) {
      return new Promise((resolve) => {
        // eslint-disable-next-line
        units.forEach(x => {
          x.productid = productId
          if (!x.issupplier) x.minqty = x.orderqty = null
        })
        let transformData = { number: { list: ['qty', 'minqty', 'orderqty'], format: 'replaceCommaWithDot' } }
        let items = this.$formatter.cloneVariable(units)
        items = this.$_formatListModel(units, transformData)
        this.$_executeApi('post', '/productunitmatrix/bulk_save', items)
          .then(async (response) => {
            this.modelObj.units = response.data
            resolve()
          })
      })
    },
    getProductUnits () {
      return new Promise((resolve) => {
        this.$_executeApi('get', `productunitmatrix/get_by_product/${this.modelObj.id}`)
          .then((response) => {
            let transformData = { number: { list: ['qty', 'minqty', 'orderqty'], format: 'replaceDotWithComma' } }
            this.modelObj.units = this.$_formatListModel(response.data, transformData)
            resolve()
          })
      })
    },
    saveProductDefaultLocations (productId, locations) {
      return new Promise((resolve) => {
        // eslint-disable-next-line
        locations.forEach(x => {
          x.productid = productId
        })
        let items = this.$formatter.cloneVariable(locations)
        this.$_executeApi('post', '/productwarehouselocation/bulk_save', items)
          .then((response) => {
            this.modelObj.defaultlocations = response.data
            resolve()
          })
      })
    },
    getProductDefaultLocations () {
      return new Promise((resolve) => {
        this.$_executeApi('get', `productwarehouselocation/get_by_product/${this.modelObj.id}`)
          .then((response) => {
            this.modelObj.defaultlocations = response.data
            resolve()
          })
      })
    },
    getAllCurrencyList () {
      this.$_executeApi('get', `currencies/get_all_currency_list`)
        .then((response) => {
          response.data.sort((a, b) => a.name.localeCompare(b.name))
          this.listOfCurrencyList = response.data
        })
    },
    navigationHandler (type, model, productId) {
      if (type === this.SAVE && !model.id) this.$router.push(`/w_h/${this.MODULE_URL}/actions/${productId}`)
      else if (type === this.UPDATE_CLOSE) this.$router.push(`/w_h/${this.MODULE_URL}`)
      else if (type === this.SAVE && model.id) this.getSingleRecordHandler()
    },
    deleteHandler () {
      let ids = [this.modelObj.id]
      let payload = { ids, url: `${this.MODULE_URL}/delete_multiple`, module: this.MODULE_URL }
      this.$store.commit('showDeleteDialog', payload)
    },
    async setGrossMarginValue () {
      if (this.modelObj.id && this.modelObj.productgroupid) {
        let query = { filter: `productid eq '${this.modelObj.id}' AND ismain eq '1'` }
        let getMainSupplier = await this.$_executeApi('post', `productsuppliers/query`, query)
        if (getMainSupplier.data) {
          let { supplierid } = getMainSupplier.data[0] ? getMainSupplier.data[0] : { id: 0 }
          if (supplierid) {
            let grossQuery = { filter: `group_id eq '${this.modelObj.productgroupid}' AND supplier_id eq '${supplierid}'` }
            let getGrossMargin = await this.$_executeApi('post', `grossmargins/query`, grossQuery)
            if (getGrossMargin.data) {
              let { gross_margin } = getGrossMargin.data[0] ? getGrossMargin.data[0] : { gross_margin: 0 }
              if (gross_margin) {
                this.modelObj.grosmargin = this.$formatter.replaceDotWithComma(gross_margin)
              } else {
                this.modelObj.grosmargin = '0,00'
              }
              this.calculatSalesPriceValue()
            }
          }
        }
      }
    },
    calculatSalesPriceValue () {
      let costPrice = this.modelObj.costprice ? this.$formatter.replaceCommaWithDot(this.modelObj.costprice) : 0
      let grosMargin = this.modelObj.grosmargin ? this.$formatter.replaceCommaWithDot(this.modelObj.grosmargin) : 0
      if (grosMargin) {
        this.modelObj.salesprice = this.$formatter.replaceDotWithComma((costPrice * (100 + (+grosMargin))) / 100)
      } else this.modelObj.salesprice = this.$formatter.replaceDotWithComma(costPrice)
      this.salesCalculationHandler('salespriceincvat', 'salesprice', 1)
    },
    calculateGrosMarginValue (type) {
      let costPrice = this.modelObj.costprice ? this.$formatter.replaceCommaWithDot(this.modelObj.costprice) : 0
      if (costPrice) {
        let salesPrice = this.modelObj.salesprice ? this.$formatter.replaceCommaWithDot(this.modelObj.salesprice) : 0
        let grosmargin = ((salesPrice - costPrice) / costPrice) * 100
        this.modelObj.grosmargin = grosmargin && !isNaN(grosmargin) && isFinite(grosmargin) ? this.$formatter.replaceDotWithComma(grosmargin) : '0,00'
      }
      if (type === 2) this.modelObj.salespriceincvat = this.$formatter.replaceDotWithComma(this.modelObj.salespriceincvat)
      else this.salesCalculationHandler('salespriceincvat', 'salesprice', 1)
    },
    setDefaultValues (data) {
      let { list, prop } = data
      let item = list.find(x => x.isdefault)
      if (item) {
        let model = Object.assign({ ...this.modelObj }, { [prop]: item.id })
        setTimeout(() => {
          this.modelObj = model
        })
      }
    },
    salesCalculationHandler (target, field, type) {
      const getVat = this.modelObj.vatid
      const getField = this.$formatter.replaceCommaWithDot(this.modelObj[field])
      let getValue = 0
      if (type === 1) {
        getValue = (+getField * (getVat + 100) / 100)
      } else if (type === 2) {
        getValue = (+getField / (getVat + 100) * 100)
      }
      this.modelObj[target] = this.$formatter.replaceDotWithComma(getValue)
      if (target === 'salesprice') this.calculateGrosMarginValue(type)
    },
    setDefaultAccount (data) {
      // eslint-disable-next-line eqeqeq
      let item = this.$store.state.listOfSalesAccounts.find(x => x.accountnumber == process.env.VUE_APP_DEFAULT_ACCOUNT_NUMBER)
      if (item) {
        let model = Object.assign({ ...this.modelObj }, { 'salesaccountid': item.id })
        setTimeout(() => {
          this.modelObj = model
        })
      }
    },
    getContentHandler () {
      this.contentLoader = true
      this.nestedDialog = true
      this.$_executeApi('get', `/productpackages/get_contents_of_nested/${this.modelObj.id}`)
        .then((response) => {
          this.nestedContents = response.data
        })
        .finally(() => {
          this.contentLoader = false
        })
    },
    priceCalculation (result) {
      const prop = result.iscopy ? 'copyPayload' : 'modelObj'
      let getPrices = this.$formatter.cloneVariable(this[prop])
      this[prop] = { ...getPrices, ...result.model }
    },
    supportingList (type, text) {
      const modelName = text
      text = this.$refs.productReference.$refs[text].lazySearch
      let model = { module: type, dialog: true, text, modelName }
      if (type === this.PRODUCT_GROUPS && (text && text.split('-').length > 1)) {
        model.number = text.split('-')[0]
        model.text = text.split('-')[1]
      }
      this.$store.commit('supportingList', model)
    },
    copyHandler () {
      this.copyProduct.dialog = true
      let copyData = this.$formatter.cloneVariable(this.modelObj)
      copyData.id = 0
      copyData.number = ''
      copyData.available = 0
      if (copyData.units) {
        copyData.units.map(x => {
          x.id = 0
          return x
        })
      }
      this.copyPayload = copyData
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
    this.$eventBus.$off('setChildData')
    this.$eventBus.$off('calculateGrosMarginValue')
    this.$eventBus.$off('checkForNumberDuplication')
    this.$eventBus.$off('calculateSalesValue')
    this.$eventBus.$off('updatedSupplier')
    this.$eventBus.$off('salesPriceHandler')
    this.$root.$off('get_product_details')
    this.$eventBus.$off('setItemInField')
    this.$eventBus.$off('updateProductUnits')
    this.$eventBus.$off('updateProductDefaultLocations')
  },
  beforeRouteLeave (to, from, next) {
    if (!this.$store.state.isChangesMade) {
      next()
    } else {
      this.$store.commit('isChangesMade', true)
      this.$store.commit('changeLostDialog', true)
    }
  }
}
</script>
